"use strict";
// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsVisualizationType = exports.LogLevelEnum = void 0;
var LogLevelEnum;
(function (LogLevelEnum) {
    LogLevelEnum["SILLY"] = "silly";
    LogLevelEnum["DEBUG"] = "debug";
    LogLevelEnum["INFO"] = "info";
    LogLevelEnum["WARN"] = "warn";
    LogLevelEnum["ERROR"] = "error";
})(LogLevelEnum || (exports.LogLevelEnum = LogLevelEnum = {}));
var AnalyticsVisualizationType;
(function (AnalyticsVisualizationType) {
    AnalyticsVisualizationType["Count"] = "count";
    AnalyticsVisualizationType["LineChart"] = "line_chart";
    AnalyticsVisualizationType["DoughnutChart"] = "doughnut_chart";
})(AnalyticsVisualizationType || (exports.AnalyticsVisualizationType = AnalyticsVisualizationType = {}));
